import { cls } from "@wss/cls";
import React from "react";
import { User } from "~/common/Store/connectUserAndChat";

interface PlusShippingProps {
  text: string;
  user?: User;
}

const baseContainerClasses = "m-0 p-0 mb-2.5 leading-6 text-[75%]";

const PlusShipping = ({ text, user }: PlusShippingProps) => {
  const containerClass = user?.hasWebPlus
    ? baseContainerClasses
    : `${baseContainerClasses} block align-baseline bg-transparent border-none cursor-pointer`;

  const content = (
    <span
      className={cls(
        "flex items-center text-gray-800",
        !user?.hasWebPlus && "hover:text-blue-500",
      )}
    >
      {text}
      <img
        src="//cdnimg.webstaurantstore.com/uploads/design/2017/8/plus_micro.svg"
        alt="Plus"
        aria-hidden="true"
        height={16}
        width={35}
        className="pl-0.5"
      />
    </span>
  );

  return user?.hasWebPlus ? (
    <span className={containerClass} data-testid="plus-shipping-text">
      {content}
    </span>
  ) : (
    <a
      className={containerClass}
      data-testid="plus-shipping-text"
      href="/plus/"
    >
      {content}
    </a>
  );
};

export default PlusShipping;
